import React, { useEffect, useState } from "react";

const STORAGE_BASE = process.env.REACT_APP_STORAGE_BASE

const DEFAULT_LOGO = `${STORAGE_BASE}default/logo.png`;

const getDomainLogo = () => {
    let domain = window.location.hostname;
    domain = domain.replace("www.", "");

    if (domain.includes("localhost")) {
        return DEFAULT_LOGO;
    }
    const parts = domain.split(".");

    if (parts.length > 2) {
        domain = parts.slice(-2).join(".");
    }

    return `${STORAGE_BASE}${domain}/logo.png`;
};

const DomainLogo = ({ className, width }) => {
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        const domainLogo = getDomainLogo();

        const img = new Image();
        img.src = domainLogo;

        img.onload = () => {
            setLogo(domainLogo);
        };

        img.onerror = () => {
            setLogo(DEFAULT_LOGO);
        };
    }, []);

    if (!logo) return null;

    return (
        <img
            src={logo}
            alt="logo"
            className={className}
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = DEFAULT_LOGO;
            }}
            width={width}
        />
    );
};

export default DomainLogo;
